angular.module('common.services').factory('edgeGroupFactory', [
  '$http',
  '$filter',
  function ($http, $filter) {
    var list
    this.list = []
    this.findItemById = function (id) {
      var returnValue = {
        status: 0
      }
      var item = $filter('filter')(this.list, function (e) {
        return e.id == id
      })
      if (item.length > 0) {
        returnValue.status = 1
        returnValue.item = item[0]
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }
    this.addOrUpdateItem = function (item) {
      var itemData = this.findItemById(item.id)
      if (itemData.status == 1) {
        this.list[itemData.index] = item
      } else {
        this.list.push(item)
      }
    }
    this.deleteItemById = function (id) {
      var itemData = this.findItemById(id)
      if (itemData.status == 1) {
        var index = itemData.index
        this.list.splice(index, 1)
      }
    }
    return this
  }
])
